export const applyDocumentTitle = (eventName: string): void => {
  window.document.title = `${eventName} - Rozie Synopsis`;
};
